import * as tslib_1 from "tslib";
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '../../../core';
var FormlyWrapperAddons = (function (_super) {
    tslib_1.__extends(FormlyWrapperAddons, _super);
    function FormlyWrapperAddons() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormlyWrapperAddons.prototype.addonRightClick = function ($event) {
        if (this.to.addonRight.onClick) {
            this.to.addonRight.onClick(this.to, this, $event);
        }
    };
    FormlyWrapperAddons.prototype.addonLeftClick = function ($event) {
        if (this.to.addonLeft.onClick) {
            this.to.addonLeft.onClick(this.to, this, $event);
        }
    };
    return FormlyWrapperAddons;
}(FieldWrapper));
tslib_1.__decorate([
    ViewChild('fieldComponent', { read: ViewContainerRef }),
    tslib_1.__metadata("design:type", ViewContainerRef)
], FormlyWrapperAddons.prototype, "fieldComponent", void 0);
FormlyWrapperAddons = tslib_1.__decorate([
    Component({
        selector: 'formly-wrapper-addons',
        template: "\n    <div class=\"input-group\">\n      <div class=\"input-group-addon\"\n        *ngIf=\"to.addonLeft\"\n        [ngStyle]=\"{cursor: to.addonLeft.onClick ? 'pointer' : 'inherit'}\"\n        (click)=\"addonLeftClick($event)\">\n        <i [ngClass]=\"to.addonLeft.class\" *ngIf=\"to.addonLeft.class\"></i>\n        <span *ngIf=\"to.addonLeft.text\">{{ to.addonLeft.text }}</span>\n      </div>\n      <ng-container #fieldComponent></ng-container>\n      <div class=\"input-group-addon\"\n        *ngIf=\"to.addonRight\"\n        [ngStyle]=\"{cursor: to.addonRight.onClick ? 'pointer' : 'inherit'}\"\n        (click)=\"addonRightClick($event)\">\n        <i [ngClass]=\"to.addonRight.class\" *ngIf=\"to.addonRight.class\"></i>\n        <span *ngIf=\"to.addonRight.text\">{{ to.addonRight.text }}</span>\n      </div>\n    </div>\n  ",
    })
], FormlyWrapperAddons);
export { FormlyWrapperAddons };
//# sourceMappingURL=addons.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/wrappers/addons.js
// module id = 781
// module chunks = 3